import { ajax } from '@/api/http'
import axios from 'axios'
// 搜索框
export const searchInfo = (data) => ajax('/pre_search', data, 'post');


// 区块列表
export const blocksList = (data) => ajax('/blocks', data, 'post');

// 根据区块高度查询详情
export const blockDetails = (data) => ajax(`/block/${data.block_number}`, data, 'get');
// 根据区块哈希查询详情
export const blockHashDetails = (data) => ajax(`/block_hash`, data, 'post');

// 交易列表
export const transactionsList = (data) => ajax(`/transactions`, data, 'post');

// 区块交易列表
export const blockTransactionsList = (data) => ajax(`/block_transactions`, data, 'post');

// 交易详情
export const transactionsDetails = (data) => ajax(`/tx/${data.address}`, data, 'get');

// 交易事件列表
export const txEventList = (data) => ajax(`/tx_event`, data, 'post');

// 普通地址交易列表
export const addressTransactions = (data) => ajax(`/address_transactions`, data, 'post');

// 查询钱包数据
export const addressWallet = (data) => ajax(`/address/${data.address}`, data, 'get');

// 内部交易列表
export const internalTransactions = (data) => ajax(`/internal_transactions`, data, 'post');

// 普通地址代币转账列表
export const tokenTransactions = (data) => ajax(`/token_transactions`, data, 'post');

// 合约代币金额排行榜/持有人列表
export const tokenAmount = (data) => ajax(`/token_amount`, data, 'post');

// 合约代币交易列表
export const tokenAddress = (data) => ajax(`/contract_address`, data, 'post');

// moreInfo
export const moreInfo = (data) => ajax(`/moreInfo`, data, 'post');


// 获取代币总数
export const getTokenCount = (data) => ajax(`/getCount`, data, 'post');

// 获取持仓总量和发行量
export const getTotalHoldings = (data) => ajax(`/getTotalSupply/${data.token}`, data, 'get');
// 获取 PCNB 余额
export const getPCNBBalance = (data) => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'post',
      url: 'https://flad-api.datatradechain.net/v2/home/scan/address/balance',
      data: {
        address: data.address
      },
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json; charset=UTF-8'
      }
    }).then(
      (response) => {
        if (response && (response.status === 200)) {
          resolve(response.data)
        } else {
          reject(response)
        }
      }
    ).catch(
      (err) => {
        reject(err)
      }
    )
  })
};